export default __webpack_public_path__ + "static/media/Bandit's Helm of the Khan.4348c3d8.jpg";